import { render, staticRenderFns } from "./jiaoyu.vue?vue&type=template&id=33eeaee9&scoped=true&"
import script from "./jiaoyu.vue?vue&type=script&lang=js&"
export * from "./jiaoyu.vue?vue&type=script&lang=js&"
import style0 from "./jiaoyu.vue?vue&type=style&index=0&id=33eeaee9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33eeaee9",
  null
  
)

export default component.exports